export const getPersonalTasksSelector = state => state.personalTasks;
